var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0561 3H1.99753C1.58596 3 1.35065 3.46947 1.59694 3.79921L8.46309 12.9919C8.52763 13.0783 8.5625 13.1833 8.5625 13.2911V20.3761C8.5625 20.6962 8.85902 20.9338 9.17139 20.8641L15.7339 19.3998C15.9625 19.3488 16.125 19.146 16.125 18.9118V13.2787C16.125 13.1785 16.1551 13.0807 16.2113 12.9978L22.4698 3.78088C22.6952 3.4489 22.4574 3 22.0561 3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.fb4c75f5752b2c780b16c801affa8c13.svg";
export { ForwardRef as ReactComponent };